import env from '@eneco/common/env';

export const isNextAuthEnabled = !!env('OKTA_OAUTH2_LOGOUT_REDIRECT_URI');
